import { AppLangCode } from '@libs/types';

export const SUMSUB_LANG_CODES = {
  [AppLangCode.EN]: 'en',
  [AppLangCode.RU]: 'ru',
  [AppLangCode.KA]: 'ka',
  [AppLangCode.UA]: 'uk',
}
